<!-- <div class="file-drop-area justify-content-center">
  <button mat-raised-button color="primary">Elija el archivo</button>
  <span>{{file ? file.name : ' o arrastre y suelte el archivo aquí ' }}</span>
  <input class="file-input" type="file">
</div> -->
<!--sdfsd-->
<!-- <div class="file-drop-area justify-content-center">
  <button mat-raised-button color="primary">
    Elija el archivo
    <input class="file-input" type="file" (change)="uploadFile($event)">
  </button>
  <span>{{ file ? 'Nombre del archivo: ' + file.name : '' }}</span>
  <div *ngIf="file" class="file-preview">
    <img [src]="filePreview" alt="Vista previa" />
  </div>
  <div class="pdf-container top-margin" [hidden]="isCropImage">
    <pdf-viewer [src]="pdfSrc" [render-text]="true" [page]="currentpage" [show-all]="false" [original-size]="true"
      [fit-to-page]="false" (after-load-complete)="afterLoadComplete($event)" style="display: block;">
    </pdf-viewer>
  </div>
  <div *ngIf="isImageUploaded">
    <img [src]="imageSrc" alt="Imagen cargada">
  </div>

  <div class="img-container" [hidden]="!isCropImage">
    <img #image src="" id="cropper-img" crossorigin>
  </div>
</div> -->

<div class="file-drop-area justify-content-center">
  <button mat-raised-button color="primary">
    Elija el archivo
    <input class="file-input" type="file" (change)="uploadFile($event)">
  </button>
  <span *ngIf="submit === 'add'">{{ file?.name }}</span>
  <div *ngIf="submit !== 'add'" class="file-preview">
    <img [src]="filePreview" alt="" />
  </div>
  <div class="pdf-container top-margin" [hidden]="isCropImage || submit === 'add'">
    <pdf-viewer [src]="pdfSrc" [render-text]="true" [page]="currentpage" [show-all]="false" [original-size]="true"
      [fit-to-page]="false" (after-load-complete)="afterLoadComplete($event)" style="display: block;">
    </pdf-viewer>
  </div>
  <div *ngIf="isImageUploaded && submit !== 'add'">
    <img [src]="imageSrc" alt="Imagen cargada">
  </div>
  <div class="img-container" [hidden]="!isCropImage && submit === 'add'">
    <img #image src="" id="cropper-img" crossorigin>
  </div>
</div>